app.service('deliveryLocation', function (console, loading, geolocation, deliveryShops, broker) {
	var $container, $self, $locations, $locationInputs, $onlyAvailable, $toggleHours;
	var deliveryUtils, refreshCallback = false;
	var scroll = false;

	broker.on('BEFORE_PAGE_CHANGE', function() {
		scroll = false;
	});

	function findNearestLocations(position) {
		var params = deliveryUtils.findNearParams(position);
		refresh(params);
	}
	function nearestItems() {
		geolocation.findPosition(function (position) {
			findNearestLocations(position);
		}, function () {
			console.log('Błąd lokalizacji')
		});
	}
	function showAvailabilty(checked) {
		if (checked) {
			$self.addClass('show-only-available');
		} else {
			$self.removeClass('show-only-available');
		}
	}
	function toogleAvailabilty() {
		showAvailabilty($onlyAvailable.prop('checked'));
	}
	function moreLocations() {
		console.log('WIĘCEJ LOKALIZACJI');
		$self.addClass('show-more-locations');
		$self.addClass('delivery-time-not-changeable');
		$self.removeClass('has-more-locations');
		$self.removeClass('show-only-selected');
		toogleAvailabilty();
	}
	function showOtherLocations() {
		$self.addClass('select-other-location');
	}
	function selectLocation($location) {
		$locations.removeClass('selected-location');
		$location.closest('.js-location').addClass('selected-location');

		deliveryUtils.selectLocation({
			city: $location.data('city'),
			shop: $location.data('shop'),
			machine: $location.data('machine')
		});
		if ($location.data('confirm')) {
			$self.addClass('show-delivery-time-message');
			$deliveryConfirm.ignore(false);
		} else {
			$self.removeClass('show-delivery-time-message');
			$deliveryConfirm.ignore(true);
		}
		$self.addClass('show-only-selected');
		if ($locations.length > 1) {
			$self.addClass('has-more-locations');
		} else {
			$self.removeClass('has-more-locations');
		}
		$('.radio-group.validate-target', $self).removeClass('validate-error');
	}

	function refreshSuccess(html, options, orgParams) {
		if (html) {
			$container.html(html);
		}
		var params = {
			shopCode: false,
			cityCode: false,
			moreLocations: false,
			locations: false,
			lastLocation: false
		};
		init();
		if ($locations.length > 3) {
			params.moreLocations = true;
			$self.addClass('has-more-locations');
		}
		if ($locations.length) {
			params.locations = true;
			$self.addClass('has-locations');
		}
		if ($self.find('#last-order-location').length) {
			params.shopCode = $('#last-order-location').data('shop');
			params.cityCode = $('#last-order-location').data('city');
			params.lastLocation = true;
		}
		
		if ((!$self.find('#last-order-location').length && !$locations.filter('.selected-location').length && $('#shop-delivery').length)) {
			// Przypadek gdy nie ma wybranego sklepu np. dla opcji taxfree wyłączonej w ostatnio wybranym sklepie
			$('#preview-order-steps .row-delivery-point').hide();
			$('#container').removeClass('hide-shops');
		}
		if (scroll && $self.length) {
			loading.stop();
			$.scrollTo($self, 200);
		} else {
			$container.removeClass('loading');
			scroll = true;
		}
		if(location.hash == '#edit-shop'){
			show();
		}

		if (refreshCallback) {
			refreshCallback(params);
		}
		deliveryUtils.refreshSuccess();
	}
	function refresh(params) {
		if (params.scroll === false) {
			scroll = false;
		}
		if (scroll) {
			loading.start();
		} else {
			$container.addClass('loading');
		}
		deliveryUtils.refresh(params, refreshSuccess);
	}
	function selectCity(cityCode) {
		// $self.removeClass('show-delivery-time-message');
		// $deliveryConfirm.ignore(true);
		var params = deliveryUtils.selectCityParams(cityCode);
		if (params) {
			refresh(params);
		}
	}

	function setElements(option) {
		if (option) {
			switch (option.deliveryType) {
				case 'shop':
					$container = $('#shops-list');
					deliveryUtils = deliveryShops;
					break;
				case 'change_payment':
					$container = $('#shops-list');
					deliveryUtils = deliveryShops;
					break;
				// case 'inpost':
				// 	$container = $('#inpost');
				// 	deliveryUtils = deliveryInpost;
				// 	break;
			}
		}
		$self = $('#location-box', $container);
		$locations = $('.js-location', $self);
		$locationInputs = $('input', $locations);
		$deliveryConfirm = $('#delivery-confirm', $self);
		$onlyAvailable = $('#only-available', $self);
		$toggleHours = $('.js-toggle-hours', $self);
		if($('#delivery-banner').length){
			if($('.delivery-badge').length){
				let $b = $('.delivery-badge').detach();
				$b.appendTo( "#delivery-banner" );
			}else {
				//$('#delivery-banner').remove();
			}
		}
	}
	function setEvents() {
		$('.js-more-locations-button').on('click', function () {
			moreLocations();
		});
		$('#city-select').on('change', function () {
			selectCity($(this).val());
		});
		$onlyAvailable.on('click', function () {
			toogleAvailabilty();
		});
		$('#find-near').on('click', function () {
			nearestItems();
		});
		$locationInputs.on('click', function () {
			selectLocation($(this));
		});
		$('.js-other-location', $self).on('click', function () {
			showOtherLocations();
		});
		$toggleHours.on('click', function (event) {
			$(this).closest('label').toggleClass('show-hours-details');
			event.preventDefault();
		});
	}
	function init(option, callback) {
		setElements(option);
		setEvents();
		if (callback) {
			refreshCallback = callback;
		}
		if (option) {
			if (!$('#search-city').length) {
				refresh(option);
			}
		}
	}
	function show(){
		showOtherLocations();
	}
	return {
		init,
		refresh,
		show
	};
});
